import { createStyles } from 'antd-style'

// Per-size caption typography, matching the Figma body-small/body-default/
// body-large tokens (12/16px, 14/18px, 16/24px).
const DESCRIPTION_FONT = {
  small: { fontSize: 12, lineHeight: '16px' },
  default: { fontSize: 14, lineHeight: '18px' },
  large: { fontSize: 16, lineHeight: '24px' }
} as const

export const useStyles = createStyles(({ css, token, prefixCls }) => ({
  // Fills (rather than shrink-wraps) its parent so the spinner always
  // centers itself — the immediate parent still needs a resolvable height
  // (e.g. a page/section container with height/min-height, or a flex/grid
  // cell) for there to be space to center within.
  root: css`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${token.paddingXS}px;
    padding: ${token.padding}px;
    box-sizing: border-box;
  `,

  // Applied to the nested/overlay antd Spin (children + replace=false).
  // antd's own tip color there defaults to colorTextDescription (grey);
  // overridden here to match the standalone caption's colorPrimary for
  // visual consistency between the two modes.
  overlay: css`
    .${prefixCls}-spin-text {
      color: ${token.colorPrimary};
    }
  `,

  // antd's own `tip` prop only renders in nested/fullscreen mode, so the
  // caption is rendered manually here instead (see Spin.tsx) — which also
  // means its color needs to be set explicitly. antd's own tip color
  // defaults to colorTextDescription (grey); Figma specs `text/action`
  // (token.colorPrimary) to match the indicator's color.
  descriptionSmall: css`
    color: ${token.colorPrimary};
    font-size: ${DESCRIPTION_FONT.small.fontSize}px;
    line-height: ${DESCRIPTION_FONT.small.lineHeight};
  `,
  descriptionDefault: css`
    color: ${token.colorPrimary};
    font-size: ${DESCRIPTION_FONT.default.fontSize}px;
    line-height: ${DESCRIPTION_FONT.default.lineHeight};
  `,
  descriptionLarge: css`
    color: ${token.colorPrimary};
    font-size: ${DESCRIPTION_FONT.large.fontSize}px;
    line-height: ${DESCRIPTION_FONT.large.lineHeight};
  `
}))
